// Team members and city coordinates
export const CITY_LATLNG = {
  "Vancouver, BC": { lng: -123.1207, lat: 49.2827 },
  "Edmonton, AB": { lng: -113.4938, lat: 53.5461 },
  "Winnipeg, MB": { lng: -97.1384, lat: 49.8951 },
  "Windsor, ON": { lng: -83.0364, lat: 42.3149 },
  "Goderich, ON": { lng: -81.7165, lat: 43.7501 },
  "Toronto, ON": { lng: -79.3832, lat: 43.6532 },
  "Barrie, ON": { lng: -79.6903, lat: 44.3894 },
  "Newmarket, ON": { lng: -79.4613, lat: 44.0592 },
  "St. Catharines, ON": { lng: -79.2469, lat: 43.1594 },
  "Fonthill, ON": { lng: -79.2843, lat: 43.0407 },
  "Montreal, QC": { lng: -73.5673, lat: 45.5017 },
  "Moncton, NB": { lng: -64.7782, lat: 46.0878 },
};

// Each member: id, name, city (display + city key), territory description.
// `offset` (lng/lat fine-tune) used to nudge co-located members apart so they
// don't render exactly on top of each other at high zoom.
export const TEAM_MEMBERS = [
  {
    id: "tm-01",
    name: "Dina Harding",
    city: "Vancouver, BC",
    cityKey: "Vancouver, BC",
    territory: "British Columbia",
  },
  {
    id: "tm-02",
    name: "Jeff Holm",
    city: "Edmonton, AB",
    cityKey: "Edmonton, AB",
    territory: "Alberta",
  },
  {
    id: "tm-03",
    name: "Landon Pearse",
    city: "Winnipeg, MB",
    cityKey: "Winnipeg, MB",
    territory: "Saskatchewan, Manitoba, Ontario Lakehead",
  },
  {
    id: "tm-04",
    name: "John Morrison",
    city: "Goderich, ON",
    cityKey: "Goderich, ON",
    territory: "South Western Ontario",
  },
  {
    id: "tm-05",
    name: "David Schmut",
    city: "Toronto, ON",
    cityKey: "Toronto, ON",
    territory: "GTA | Central Ontario",
  },
  {
    id: "tm-06",
    name: "Glenn Truelove",
    city: "Barrie, ON",
    cityKey: "Barrie, ON",
    territory: "Northern | Eastern Ontario",
  },
  {
    id: "tm-07",
    name: "Erick Desormeaux",
    city: "Montreal, QC",
    cityKey: "Montreal, QC",
    territory: "Quebec — Industrial & Rental",
  },
  {
    id: "tm-08",
    name: "Fannie Amiot",
    city: "Montreal, QC",
    cityKey: "Montreal, QC",
    territory: "Quebec — Hardware, Automotive & Retail",
  },
  {
    id: "tm-09",
    name: "Travis Matheson",
    city: "Moncton, NB",
    cityKey: "Moncton, NB",
    territory: "New Brunswick | Nova Scotia | PEI | Newfoundland & Labrador",
  },
  {
    id: "tm-10",
    name: "Cam Bull",
    city: "St. Catharines, ON",
    cityKey: "St. Catharines, ON",
    territory: "Vice President — Technical | Marketing",
  },
  {
    id: "tm-11",
    name: "Mark Bull",
    city: "Fonthill, ON",
    cityKey: "Fonthill, ON",
    territory: "Vice President — Retail | Sales",
  },
  {
    id: "tm-12",
    name: "Frank Lupo",
    city: "Newmarket, ON",
    cityKey: "Newmarket, ON",
    territory: "National Sales Manager",
  },
  {
    id: "tm-13",
    name: "Alan Bull",
    city: "Windsor, ON",
    cityKey: "Windsor, ON",
    territory: "President",
  },
];
